<template>
  <CustomPage :noTitle="true" class="newcomer-container">
    <div slot="content" class="content">
      <div
        class="newcomer-container"
        :style="{ backgroundColor: data.backgroundColor }"
      >
        <CustomHead
          title="新人会场"
          :navBarToggle="true"
          scrollDOM=".newcomer-container .wrapper"
          @sharePoster="sharePoster"
        />
        <div class="banner">
          <img :src="data.image" alt="" />
        </div>
        <template v-for="item in list">
          <component
            :is="panel_c(item.themeType)"
            :key="item.actThemeId"
            :data="item"
          />
        </template>
        <div class="finish"></div>
      </div>
      <CustomView />
    </div>
  </CustomPage>
</template>

<script>
import CustomPage from '@/components/custom-page'
import CustomView from '@/components/custom-view'
import CustomHead from "@/components/custom-head";
import PanelBrand from "@/components/activity/panel/brand";
import PanelGoods from "@/components/activity/panel/goods";
import PanelSuit from "@/components/activity/panel/suit";
import { getNewcomerDetail, getNewcomerList } from "@/api/newcomer";
import { newcomerShare } from "@/api/forward";
export default {
  components: { CustomPage, CustomView, CustomHead, PanelBrand, PanelGoods, PanelSuit },
  data() {
    return {
      data: {
        image: null,
        backgroundColor: "#e82035",
      },
      list: [],
    };
  },
  computed: {
    panel_c() {
      return (type) => {
        switch (type) {
          case "brand":
            return "PanelBrand";
          case "goods":
            return "PanelGoods";
          case "suit":
            return "PanelSuit";
        }
      };
    },
  },
  created() {
    this.getData();
  },
  methods: {
    getData() {
      this.$store.dispatch("app/showLoading");
      Promise.all([getNewcomerDetail(), getNewcomerList()])
        .then(([res1, res2]) => {
          // res1
          this.$store.dispatch("app/hideLoading");
          this.data.image = res1.data.bannerUrl[0];
          this.data.backgroundColor = res1.data.colorCode;
          // res2
          this.list = this.converData(res2.data);
        })
        .catch(() => {
          this.$store.dispatch("app/hideLoading");
        });
    },
    converData(data) {
      data.forEach((item) => {
        if (item.themeType === "suit") {
          item.themeSuitH5List.forEach((_item) => {
            _item.activityReward = "NEWBIE";
          });
        }
        if (item.themeType === "goods") {
          item.themeGoodsList.forEach((_item) => {
            _item.activityReward = "NEWBIE";
          });
        }
        if (item.themeType === "brand") {
          item.themeBrandList.forEach((_item) => {
            _item.activityReward = "NEWBIE";
          });
        }
      });
      return data;
    },
    sharePoster() {
      let forwardUrl = `${window.location.origin}/newcomer?customerId=${this.$store.state.user.forwardId}`;
      this.$store.dispatch("app/showLoading");
      newcomerShare({ url: forwardUrl })
        .then((res) => {
          this.$store.dispatch("app/hideLoading");

          this.sharePosterOpen(res.data, forwardUrl);
        })
        .catch(() => {
          this.$store.dispatch("app/hideLoading");
        });
    },
    sharePosterOpen(url, forwardUrl) {
      this.$store.dispatch("sharePoster/show", {
        url,
        title: "新人会场",
        desc: "新人会场",
        link: forwardUrl,
        imgUrl: "",
      });
    },
  },
};
</script>

<style lang="less" scoped>
.newcomer-container {
  min-height: 100%;
}
.banner {
  img {
    width: 100%;
  }
}
.custom-head {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
}
.finish {
  padding: 60px 0;
  font-size: 24px;
  font-weight: 600;
  color: #ffffff;
  line-height: 28px;
  text-align: center;
}
</style>